<template>
  <div class="simulator_wrapper">
    <div class="simulator">
      <PaintCanvas v-show="edit_mode === CONST.EDIT_MODE_CLIPPING" class="paint" :width="paint_canvas_width" :height="paint_canvas_height" :margin="margin" />
      <MainCanvas class="main_image" @change_bg_img="setAutoScaleEvent"/>
    </div>
  </div>
</template>

<script>
  import MainCanvas from './vue_konva/MainCanvas';
  import PaintCanvas from './PaintCanvas';

  import Util from '../../assets/js/util'
  import CONST from '../../assets/js/const'

  import { mapMutations, mapState, mapGetters } from 'vuex'
  import Modal from "../modal/Modal";

  export default {
    name: 'SimulatedImage',
    components: {Modal, MainCanvas,PaintCanvas },
    data: () => ({
      CONST,
      paint_canvas_width: 100,
      paint_canvas_height: 100,
      margin: { marginTop: '0px', marginLeft: '0px' }
    }),
    computed: {
      ...mapState(['current_image', 'edit_mode', 'rect_width', 'is_check_pattern', 'is_curtain']),
      ...mapState('simulator', ['editing_id']),
      ...mapGetters('simulator', ['editing_item'])
    },
    methods: {
      ...mapMutations('simulator', ['updateItem', 'setIsOperating']),
      ...mapMutations(['setCanvasScale']),
      //ウィンドウサイズによってDOMのサイズを変えると管理が面倒そうなので
      //要素自体をスケールして対応。
      setAutoScaleEvent({ ratio, marginTop, marginLeft }) {
        this.margin = { marginTop, marginLeft }
        const canvas_el = this.$el.querySelector('.main_image');
        const simulator_el = this.$el.querySelector('.simulator');
        const wrapper_el = this.$el;
        simulator_el.style.height = `${canvas_el.clientHeight}px`;
        simulator_el.style.width = `${canvas_el.clientWidth}px`;
        const adjustScaleRootElement = () => {
          const parent_width = Util.getWidthWithoutPadding(wrapper_el);
          const scale = parent_width / canvas_el.clientWidth;
          this.setCanvasScale(scale);
          simulator_el.style.transform = `scale(${scale})`;
          wrapper_el.style.height = `${canvas_el.clientHeight * scale}px`;
          this.paint_canvas_width = canvas_el.clientWidth;
          this.paint_canvas_height = canvas_el.clientHeight;
          if (marginTop === '0px') {
            this.paint_canvas_width = canvas_el.clientWidth * ratio;
            this.paint_canvas_height = canvas_el.clientHeight;
          } else {
            this.paint_canvas_width = canvas_el.clientWidth;
            this.paint_canvas_height = canvas_el.clientHeight * ratio;
          }
        };
        //スクロールバーの有無でbodyのclientWidthが変化するのを通常のresizeイベントで検知できないので
        //自前のイベントを発行して対応しています。
        // Util.removeAllEventListeners();
        Util.addBodyResizeEventLister(adjustScaleRootElement);
        adjustScaleRootElement();
      },

    }
  }
</script>

<style scoped lang="scss">
  div.simulator {
    border: 1px #aaa solid;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    width: 100%;
    position: relative;
    transform-origin: top left;
    .main_image{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
    }
    .editable{
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 3;
    }
    .paint{
      position: absolute;
      opacity: 0.4;
      top: 0;
      left: 0;
      z-index: 2;
    }
  }
</style>
